import { cn } from "@/lib";
import { FlexBetween } from "./ui";
import { BdCloseCircle } from "solar-icon-react/bd";
import Portal from "./globalPortal";
import CustomButton from "./ui/customButton";
import { useModalStore } from "@/store";

const RulesDialog = () => {
  const { closeModal } = useModalStore();
  return (
    <Portal>
      <div
        className={cn("fixed inset-0 z-50 flex items-center justify-center")}
      >
        <div
          className={cn(
            "fixed inset-0 bg-black/50 transition-opacity duration-300",
          )}
        />
        <div
          className={cn(
            "relative z-50 mx-8 w-full max-w-md overflow-hidden rounded-xl bg-white shadow-xl sm:mx-0",
          )}
        >
          {/* Header */}
          <FlexBetween
            className={cn("bg-primary-main border-b px-6 py-3 text-white")}
          >
            <h2>قوانین و مقررات استفاده از خدمات نوین وان</h2>
            <BdCloseCircle
              onClick={closeModal}
              size={25}
              className={cn("cursor-pointer text-white!")}
            />
          </FlexBetween>
          {/* Content */}
          <div className="max-h-[60vh] overflow-y-auto p-6 md:max-h-[70vh]">
            <div>
              <h4 className="text-base font-bold">1. مقدمه</h4>
              <p className="p-2 text-sm">
                استفاده از وب‌سایت و خدمات نوین وان (novin.one) به معنای پذیرش
                کامل و بی‌قید و شرط این قوانین است. این سند، توافق‌نامه‌ای میان
                کاربر و سامانه نوین وان بوده و کلیه حقوق، تعهدات و مسئولیت‌ها را
                مشخص می‌سازد.
              </p>
            </div>
            <div>
              <h4 className="text-base font-bold">2. تعاریف</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  <span>نوین وان:</span>
                  <span className="mx-1">
                    به سامانه استعلامات آنلاین novin.one اطلاق می‌شود.
                  </span>
                </li>
                <li className="my-2 text-sm">
                  <span>کاربر حقیقی:</span>
                  <span className="mx-1">
                    شخصی که به‌صورت فردی از خدمات سامانه استفاده می‌کند.
                  </span>
                </li>
                <li className="my-2 text-sm">
                  <span>کاربر حقوقی (سازمانی): </span>
                  <span className="mx-1">
                    شرکت‌ها، مؤسسات یا کسب‌وکارهایی که از خدمات B2B، اعم از API
                    و پنل سازمانی استفاده می‌کنند.
                  </span>
                </li>
                <li className="my-2 text-sm">
                  <span>سرویس استعلامی: </span>
                  <span className="mx-1">
                    خدماتی شامل استعلام شماره کارت، شبای بانکی، کد پستی، اطلاعات
                    خودرو، استعلام شرکت، تطبیق شماره موبایل و کد ملی، و احراز
                    هویت.
                  </span>
                </li>
                <li className="my-2 text-sm">
                  <span>API: </span>
                  <span className="mx-1">
                    رابط برنامه‌نویسی نوین وان که برای اتصال مستقیم و خودکار به
                    سرویس‌های استعلامی برای کسب‌وکارها ارائه می‌شود.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">3. شرایط استفاده از خدمات</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  کاربران موظف‌اند تنها اطلاعات دقیق و واقعی خود را وارد نمایند.
                </li>
                <li className="my-2 text-sm">
                  استفاده از اطلاعات اشخاص ثالث بدون اجازه، تخلف محسوب شده و
                  تبعات حقوقی دارد.
                </li>
                <li className="my-2 text-sm">
                  مسئولیت استفاده از سرویس‌ها به‌صورت کامل بر عهده کاربر است.
                </li>
                <li className="my-2 text-sm">
                  نوین وان هیچ‌گونه مسئولیتی در قبال نتایج حاصل از تصمیمات
                  کاربران بر اساس داده‌های استعلام‌شده ندارد.
                </li>
                <li className="my-2 text-sm">
                  دسترسی کاربران در صورت تخلف از قوانین، بدون اطلاع قبلی مسدود
                  خواهد شد.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">4. هزینه و پرداخت</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  هزینه هر خدمت پیش از ثبت درخواست در صفحه مربوطه به‌صورت شفاف
                  درج شده است.
                </li>
                <li className="my-2 text-sm">
                  پرداخت‌ها از طریق درگاه بانکی امن انجام می‌شود.
                </li>
                <li className="my-2 text-sm">
                  در صورت موفق نبودن فرآیند استعلام و پرداخت وجه، بررسی و
                  بازپرداخت تنها در صورت ثبت مستندات از سمت کاربر ممکن خواهد
                  بود.
                </li>
                <li className="my-2 text-sm">
                  بازپرداخت در صورت موفق بودن عملیات و نمایش نتیجه انجام نخواهد
                  شد.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">5. محدودیت مسئولیت</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  نوین وان صرفاً به‌عنوان واسط میان کاربر و مراجع رسمی (شاپرک،
                  ثبت احوال، ثبت شرکت‌ها، راهور، بانک‌ها و...) عمل می‌کند.
                </li>
                <li className="my-2 text-sm">
                  نوین وان هیچ مسئولیتی در قبال صحت یا به‌روزرسانی لحظه‌ای
                  اطلاعات دریافتی از این مراجع ندارد.
                </li>
                <li className="my-2 text-sm">
                  در صورت اختلال در سیستم یا قطعی خدمات، تیم پشتیبانی در اسرع
                  وقت پیگیری خواهد کرد، اما ضمانت بی‌وقفه بودن سرویس وجود ندارد.
                </li>
                <li className="my-2 text-sm">
                  مسئولیت هرگونه سوءاستفاده از خدمات، اطلاعات یا نتایج استعلام
                  بر عهده کاربر می‌باشد.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">6. محرمانگی اطلاعات</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  اطلاعات شخصی کاربران نزد نوین وان محفوظ و محرمانه خواهد بود.
                </li>
                <li className="my-2 text-sm">
                  اطلاعات کاربران به هیچ عنوان به اشخاص ثالث فروخته یا منتقل
                  نخواهد شد، مگر با حکم مقام قضایی.
                </li>
                <li className="my-2 text-sm">
                  سامانه از پروتکل‌های امنیتی روز برای حفاظت از داده‌های کاربران
                  استفاده می‌کند.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">
                7. شرایط اختصاصی کاربران سازمانی (B2B){" "}
              </h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  کاربران سازمانی شامل شرکت‌ها، استارتاپ‌ها، فین‌تک‌ها و
                  کسب‌وکارهایی هستند که از خدمات نوین وان به‌صورت <b>انبوه</b>{" "}
                  یا از طریق <b>API</b> استفاده می‌کنند.
                </li>
                <li className="my-2 text-sm">
                  این کاربران موظف‌اند پیش از دریافت دسترسی API، قرارداد رسمی یا
                  توافق‌نامه همکاری با نوین وان امضا نمایند.
                </li>
                <li className="my-2 text-sm">
                  استفاده بیش از سقف مجاز، یا ارسال درخواست‌های پی‌در‌پی بدون
                  رعایت سیاست مصرف منصفانه (Fair Use)، منجر به مسدودسازی موقت یا
                  دائم دسترسی خواهد شد.
                </li>
                <li className="my-2 text-sm">
                  نوین وان مجاز است در صورت تغییر در قوانین کشور یا مراجع
                  بالادستی، دسترسی یا خدمات خاصی را به‌صورت موقت یا دائم برای
                  کاربران سازمانی محدود یا متوقف نماید.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">8. شرایط استفاده از API</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  دسترسی به API صرفاً برای کاربران تاییدشده فراهم است.
                </li>
                <li className="my-2 text-sm">
                  هر درخواست API باید حاوی کلید امنیتی (API Key) اختصاصی باشد که
                  فقط در اختیار مصرف‌کننده قرار می‌گیرد.
                </li>
                <li className="my-2 text-sm">
                  در صورت نشت یا استفاده غیرمجاز از کلید API، مسئولیت کلیه تبعات
                  بر عهده مصرف‌کننده است.
                </li>
                <li className="my-2 text-sm">
                  مصرف API فقط برای مقاصد مشروع، قانونی و مرتبط با فعالیت آن
                  کسب‌وکار مجاز است.
                </li>
                <li className="my-2 text-sm">
                  هرگونه مانیتورینگ، کش کردن داده‌ها، یا ذخیره‌سازی دائمی
                  اطلاعات بدون توافق قبلی ممنوع است.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold">9. مالکیت داده و محتوا</h4>
              <ul className="list-disc pr-4">
                <li className="my-2 text-sm">
                  کلیه نتایج، طراحی‌ها، کدها، متون، رابط‌های کاربری و محتوای
                  موجود در سامانه نوین وان متعلق به این مجموعه بوده و تحت حفاظت
                  قوانین کپی‌رایت و مالکیت معنوی قرار دارند.
                </li>
              </ul>
            </div>
          </div>
          <CustomButton className={cn("my-5 w-max")} onClick={closeModal}>
            قوانین و مقررات را میپذیرم
          </CustomButton>
        </div>
      </div>
    </Portal>
  );
};

export default RulesDialog;
